<template>
    <div
        class="uk-height-1-1 uk-width-1-1 uk-background-primary uk-border-rounded uk-box-shadow-small uk-padding-small graph-container"
    >
        <div class="graph-buttons uk-width-1-1">
            <graph-help :graph-id="id" />
            <graph-button @modeSwitch="isNumber = !isNumber" />
        </div>
        <!-- <graph-submenu :position="graphPosition" /> -->

        <div v-show="isNumber" class="uk-margin-medium-left">
            <span class="uk-text-small-number">{{ title }}</span
            ><br />
            <span class="uk-margin-auto uk-heading-medium uk-margin-none uk-text-bolder">
                {{ getAggregatedValue }} </span
            ><br />
            <span v-if="difference !== 0" class="uk-text-meta">
                <span
                    class="transition-transform"
                    :class="{ 'uk-text-danger': difference < 0, 'uk-text-success': difference > 0 }"
                >
                    <i :class="{ 'rotate-135': difference < 0, 'rotate-45': difference > 0 }">
                        <img
                            :src="require('@/assets/images/icons/icon-arrow-up.svg')"
                            class="transition-transform"
                            :class="{
                                'rotate-90': difference < 0,
                                'uk-fill-danger': difference < 0,
                            }"
                            uk-svg
                        />
                    </i>
                    {{ differenceLocal }}%
                </span>
                change to the previous period
            </span>
            <span v-else class="uk-text-meta">
                <span class="uk-text-warning"> {{ differenceLocal }}% </span> change to the previous period
            </span>
        </div>

        <div v-show="!isNumber" class="uk-position-medium uk-position-top-left">
            <span class="uk-text-large uk-text-lead uk-text-bolder">{{ getAggregatedValue }}</span>
            <span
                v-if="difference !== 0"
                class="uk-text-small-number margin-left-small"
                :class="{ 'uk-text-danger': difference < 0, 'uk-text-success': difference > 0 }"
            >
                <i :class="{ 'rotate-135': difference < 0, 'rotate-45': difference > 0 }">
                    <img
                        v-if="difference !== 0"
                        :src="require('@/assets/images/icons/icon-arrow-up.svg')"
                        class="transition-transform"
                        :class="{
                            'rotate-90': difference < 0,
                            'uk-fill-danger': difference < 0,
                        }"
                        uk-svg
                    />
                </i>
                {{ differenceLocal }}%
            </span>
            <span v-else>
                <span class="uk-text-warning margin-left-small"> {{ differenceLocal }}% </span> </span
            ><br />
            <span class="uk-text-meta uk-position-center-left uk-padding-top-60 no-wrap">{{ title }}</span>
        </div>

        <line-part v-if="!isNumber" :chart-data="getChartData" />

        <slot />

        <graph-modal :graph-id="id" :title="title" :description="description" />
    </div>
</template>

<script lang="js">
import GraphButton from "./graphParts/GraphButton.vue";
import LinePart from "./graphParts/LinePart.vue";
import GraphsMixin from "@/mixins/graphs-mixin";
import GraphHelp from "./graphParts/GraphHelp.vue";
import GraphModal from "./graphParts/GraphModal.vue";

export default GraphsMixin.extend({
    name: "NumberGraph",
    components: { GraphButton, LinePart, GraphHelp, GraphModal },
    mixins: [GraphsMixin],
    data() {
        return {
            activeSubmenu: false,
            isNumber: true,
        };
    },
});
</script>
